// The tilt's maths, as the server has them (app/models/lists.rb). The dice
// are mulberry32 and must agree bit for bit with Lists::Dice, so the sway
// the browser draws is the sway the server judges the strike against. The
// verdict here is a preview; the herald's word is the server's.

export function seedOf(hex) {
  return parseInt(String(hex).slice(0, 8), 16) >>> 0
}

export function dice(seed) {
  let a = seed >>> 0
  const roll = () => {
    a = (a + 0x6D2B79F5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
  roll.between = (lo, hi) => lo + (roll() * (hi - lo))
  return roll
}

export const HELM_ABOVE = 0.18
export const HELM_REACH = 0.06
export const SHIELD_REACH = 0.14
export const GLANCE_REACH = 0.30
export const PERFECT_MS = 70
export const CLEAN_MS = 170
export const RAGGED_MS = 320
export const ZONE_POINTS = { helm: 5, shield: 3, glance: 1, miss: 0 }
export const BROKEN_LANCE = 2

export function pattern(seed, passIndex) {
  const roll = dice((seed ^ Math.imul(passIndex + 1, 0x9E3779B9)) >>> 0)
  return {
    meetMs: Math.round(1900 + (roll() * 500)),
    a1: roll.between(0.06, 0.12), w1: roll.between(0.0009, 0.0017), p1: roll.between(0, 2 * Math.PI),
    a2: roll.between(0.03, 0.07), w2: roll.between(0.0020, 0.0040), p2: roll.between(0, 2 * Math.PI),
    drift: roll.between(0.6, 1.0)
  }
}

// The rival's shield, 0 at their crown and 1 at the saddle, t ms into the pass.
export function sway(p, t) {
  return 0.5 + (p.a1 * Math.sin((p.w1 * t) + p.p1)) + (p.a2 * Math.sin((p.w2 * t) + p.p2))
}

export function judge(p, strikeMs, aim) {
  const error = Math.abs(strikeMs - p.meetMs)
  if (error > RAGGED_MS) return { zone: "miss", timing: "wide", points: 0, broke: false }

  const shield = sway(p, Math.min(Math.max(strikeMs, 0), p.meetMs))
  aim = Math.min(Math.max(aim, 0), 1)
  let zone
  if (Math.abs(aim - (shield - HELM_ABOVE)) <= HELM_REACH) zone = "helm"
  else if (Math.abs(aim - shield) <= SHIELD_REACH) zone = "shield"
  else if (Math.abs(aim - shield) <= GLANCE_REACH) zone = "glance"
  else zone = "miss"
  const timing = error <= PERFECT_MS ? "perfect" : error <= CLEAN_MS ? "clean" : "ragged"

  let points = ZONE_POINTS[zone]
  if (timing === "ragged") points = Math.ceil(points / 2)
  const broke = timing === "perfect" && points >= ZONE_POINTS.shield
  if (broke) points += BROKEN_LANCE
  return { zone, timing, points, broke }
}
